var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user === "LOADING"
    ? _c(
        "div",
        { staticClass: "layout-column flex-center" },
        [_c("rbv-loading", { attrs: { label: "Loading, please wait..." } })],
        1
      )
    : _c("div", [
        _c("div", { class: _vm.$style.header }, [
          _c("div", { class: _vm.$style.headerStatus }, [
            _c(
              "i",
              {
                staticClass: "material-icons",
                class: _vm.$style.headerStatusIcon,
              },
              [_vm._v("check_circle")]
            ),
            _c("span", { class: _vm.$style.headerStatusLabel }, [
              _vm._v("Verified User"),
            ]),
          ]),
          _c("h2", { class: _vm.$style.headerTitle }, [
            _vm._v(
              _vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName)
            ),
          ]),
        ]),
        _c("div", { class: _vm.$style.section }, [
          _c("div", { class: _vm.$style.sectionHeading }, [
            _c(
              "div",
              {
                staticClass: "material-icons",
                class: _vm.$style.sectionHeadingIcon,
              },
              [_vm._v("account_circle")]
            ),
            _c("div", { class: _vm.$style.sectionHeadingLabel }, [
              _vm._v("Personal Information"),
            ]),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "rbButton smallIcon",
                  on: { click: _vm.editPersonalInfo },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("mode_edit"),
                  ]),
                ]
              ),
            ]),
          ]),
          _c("div", { class: _vm.$style.sectionContent }, [
            _c("div", { class: _vm.$style.detailsRow }, [
              _c("div", { class: _vm.$style.detailsLabel }, [
                _vm._v("First Name"),
              ]),
              _c("div", { class: _vm.$style.detailsValue }, [
                _vm._v(_vm._s(_vm.user.firstName)),
              ]),
            ]),
            _c("div", { class: _vm.$style.detailsRow }, [
              _c("div", { class: _vm.$style.detailsLabel }, [
                _vm._v("Last Name"),
              ]),
              _c("div", { class: _vm.$style.detailsValue }, [
                _vm._v(_vm._s(_vm.user.lastName)),
              ]),
            ]),
            _c("div", { class: _vm.$style.detailsRow }, [
              _c("div", { class: _vm.$style.detailsLabel }, [_vm._v("Phone")]),
              _c("div", { class: _vm.$style.detailsValue }, [
                _vm._v(_vm._s(_vm.user.phone || "-") + " "),
              ]),
            ]),
          ]),
        ]),
        _vm.user.accountName
          ? _c("div", { class: _vm.$style.section }, [
              _c("div", { class: _vm.$style.sectionHeading }, [
                _c(
                  "div",
                  {
                    staticClass: "material-icons",
                    class: _vm.$style.sectionHeadingIcon,
                  },
                  [_vm._v("business_center")]
                ),
                _c("div", { class: _vm.$style.sectionHeadingLabel }, [
                  _vm._v(
                    "Account Options [" + _vm._s(_vm.user.accountName) + "]"
                  ),
                ]),
              ]),
              _c("div", { class: _vm.$style.sectionContent }, [
                _c("div", { class: _vm.$style.detailsRow }, [
                  _c("div", { class: _vm.$style.detailsLabel }, [
                    _vm._v("Job Title"),
                  ]),
                  _c("div", { class: _vm.$style.detailsValue }, [
                    _vm._v(_vm._s(_vm.user.accountJobTitle || "-")),
                  ]),
                  _c("div", { class: _vm.$style.detailsEdit }, [
                    _c(
                      "button",
                      {
                        staticClass: "rbButton smallIcon",
                        on: { click: _vm.editJobTitle },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("mode_edit"),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _c("div", { class: _vm.$style.section }, [
          _c("div", { class: _vm.$style.sectionHeading }, [
            _c(
              "div",
              {
                staticClass: "material-icons",
                class: _vm.$style.sectionHeadingIcon,
              },
              [_vm._v("settings")]
            ),
            _c("div", { class: _vm.$style.sectionHeadingLabel }, [
              _vm._v("Credentials"),
            ]),
          ]),
          _c("div", { class: _vm.$style.sectionContent }, [
            _c("div", { class: _vm.$style.detailsRow }, [
              _c("div", { class: _vm.$style.detailsLabel }, [
                _vm._v("Sign In Email Address"),
              ]),
              _c("div", { class: _vm.$style.detailsValue }, [
                _vm._v(_vm._s(_vm.user.emailAddress)),
              ]),
              _c("div", { class: _vm.$style.detailsEdit }, [
                _c(
                  "button",
                  {
                    staticClass: "rbButton smallIcon",
                    on: { click: _vm.editEmail },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("mode_edit"),
                    ]),
                  ]
                ),
              ]),
            ]),
            _c("div", { class: _vm.$style.detailsRow }, [
              _c("div", { class: _vm.$style.detailsLabel }, [
                _vm._v("Password"),
              ]),
              _c("div", { class: _vm.$style.detailsValue }, [
                _vm._v("**************"),
              ]),
              _c("div", { class: _vm.$style.detailsEdit }, [
                _c(
                  "button",
                  {
                    staticClass: "rbButton smallIcon",
                    on: { click: _vm.editPassword },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("mode_edit"),
                    ]),
                  ]
                ),
              ]),
            ]),
            _c("div", { class: _vm.$style.detailsRow }, [
              _c("div", { class: _vm.$style.detailsLabel }, [
                _vm._v("Multi-factor Authentication (MFA)"),
              ]),
              _c("div", { class: _vm.$style.detailsValue }, [
                _vm._v(_vm._s(_vm.formatMfa(_vm.user.mfa))),
              ]),
              _c("div", { class: _vm.$style.detailsEdit }, [
                _c(
                  "button",
                  {
                    staticClass: "rbButton smallIcon",
                    on: { click: _vm.editMultiFactorAuthentication },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("mode_edit"),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }